import React, { useState, useEffect } from "react";
import { globalMarketOverview } from "../services/api";
import Button from "./Button";
import CoinTable from "./CoinTable";
import SignUpSection from "./SignUpSection";
import StepsSection from "./StepsSection";
const formatLargeNumber = (number) => {
  if (number >= 1e9) {
    return (number / 1e9).toFixed(2) + "B";
  } else if (number >= 1e6) {
    return (number / 1e6).toFixed(2) + "M";
  } else if (number >= 1e3) {
    return (number / 1e3).toFixed(2) + "K";
  } else {
    return number.toFixed(2);
  }
};
const Home = () => {
  const [globalMarketData, setGlobalMarketData] = useState(null);

  useEffect(() => {
    globalMarketOverview()
      .then((response) => {
        setGlobalMarketData(response.data);
      })
      .catch((error) => {
        console.error("Error loading data:", error);
      });
  }, []);

  return (
    <div>
      <div className="container relative flex flex-col justify-between mt-16 md:mt-32 lg:flex-row lg:space-x-14">
        <div className="flex-1">
          <p className="text-lg text-gray-600">
            The future of crypto-trading information
          </p>
          <p className="my-5 text-4xl font-bold">
            For Global Crypto Details
            <span className="italic font-medium cursor-pointer text-transparent animate-text bg-gradient-to-r from-blue-500 via-cyan-500 to-violet-500 bg-clip-text">
              <br /> ~ CoinWatch
            </span>
          </p>
          <Button scrollTo={850}>Take a look</Button>
        </div>
        {globalMarketData && (
          <div className="flex flex-col flex-1 pt-8 text-gray-600 md:pt-0 md:flex-row md:space-x-16 ">
            <>
              <p>
                Total Cryptocurrencies:
                <br />
                <span className="text-2xl font-bold">
                  {globalMarketData.cryptocurrencies_number}
                </span>
              </p>
            </>
            <>
              <p>
                24-Hour Trading Volume:
                <br />
                <span className="text-2xl font-bold">
                  ${formatLargeNumber(globalMarketData.volume_24h_usd)}
                </span>
              </p>
            </>
            <>
              <p>
                Total Market Cap:
                <br />
                <span className="text-2xl font-bold">
                  ${formatLargeNumber(globalMarketData.market_cap_usd)}
                </span>
              </p>
            </>
          </div>
        )}
      </div>
      <CoinTable />
      <SignUpSection />
      <StepsSection />
    </div>
  );
};

export default Home;
